import React, { useState } from "react";
import CardTable from "../../../components/AdminTable/CardTable";
import Dropdown from "../../../components/AdminDropdown/Dropdown";

function Vendor() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    
    },
    {
      header: "Vendor Name",
      accessorKey: "VendorName",
    },
    {
      header: "Phone",
      accessorKey: "Phone",
    },
    {
      header: "Description",
      accessorKey: "Description",
    },
    {
      header: "Added By",
      accessorKey: "AddedBy",
    },
    {
      header: "Actions",
      accessorKey: "total",
      cell: (row) => <Dropdown />,
    },

  ]);
  const [data] = useState([
 
  ]);
  const [buttonData] = useState([
    {
      buttonText: "Add Vendor",
      path: "addVendorForm"
    },
  ]);
 
  return (
    <main>
      <CardTable
        data={data}
        columns={columns}
        heading={"Vendors"}
        buttonData={buttonData}
      />
    </main>
  );
}

export default Vendor;
